type EditorInstance = any;
type ListboxInstance = {
  // eslint-disable-next-line no-unused-vars
  value: (value: string | null) => void;
};
type MenuItemType = {
  text: string;
  value: string | null;
  icon?: string;
  textStyle?: () => string;
  onclick: () => void;
};
type ElementType = {
  parents: ElementType[];
};

const DEFAULT_FONT_SIZES = [
  '8px',
  '10px',
  '12px',
  '14px',
  '16px',
  '18px',
  '21px',
  '24px',
  '28px',
  '32px',
  '36px',
  '42px',
  '48px',
  '56px',
  '64px',
  '72px',
  '80px',
  '88px',
  '96px',
  '104px',
  '120px',
  '144px',
];
const DEFAULT_FONT_SIZE = '16px';
const PIXEL_REGEX = /\d+px/;
const themeFontSizes: { [key: string]: string } = window.Kajabi?.themeBuilder?.fontSizes || [];
const themeFontSizeValues: string[] = Object.values(themeFontSizes);

export const register = (editor: EditorInstance) => {
  // eslint-disable-next-line
  const createFontSizeListBoxChangeHandler = function (
    editor: EditorInstance,
    items: MenuItemType[],
  ) {
    return function (this: ListboxInstance) {
      const self = this;

      editor.on('init nodeChange', (element: ElementType) => {
        let selectValue: string | null = null;
        const { formatter } = editor;
        const { parents: elementParents } = element;

        const currentPx = editor.queryCommandValue('FontSize');

        if (PIXEL_REGEX.test(currentPx)) {
          selectValue = currentPx;
        }

        const matchFormat = (node: ElementType) => {
          Object.keys(themeFontSizes).forEach((tag: string) => {
            if (!selectValue && formatter.matchNode(node, tag)) {
              // @ts-ignore:next-line
              selectValue = themeFontSizes[tag];
            }
          });
        };

        elementParents.forEach((node: ElementType) => {
          if (!selectValue) {
            matchFormat(node);
          }
        });

        if (!selectValue) {
          selectValue = DEFAULT_FONT_SIZE;
        }

        self.value(selectValue);
      });
    };
  };

  const editorFontSizes = editor.settings.fontsize_formats?.split(' ') || DEFAULT_FONT_SIZES;

  const combinedFontSizes = Array.from(new Set([...editorFontSizes, ...themeFontSizeValues]));
  const sortedFontSizes = combinedFontSizes.sort((a, b) => {
    const aPx = parseInt(a.replace('px', ''), 10);
    const bPx = parseInt(b.replace('px', ''), 10);

    return aPx - bPx;
  });

  const menuItems: MenuItemType[] = sortedFontSizes.map((fontSize) => ({
    text: fontSize,
    value: fontSize,
    onclick: () => editor.execCommand('FontSize', false, fontSize),
  }));

  editor.addButton('builder_fontsizeselect', {
    type: 'listbox',
    text: DEFAULT_FONT_SIZE,
    icon: false,
    fixedWidth: true,
    menu: menuItems,
    onPostRender: createFontSizeListBoxChangeHandler(editor, menuItems),
  });
};
